/* ============================================================
   CART VALIDATION ENGINE — Phase 2 additions
   Adds: Company Name validation, Custom Background dropdown & modal,
         Plate Meaning validation, second-Package warning.
   Loads AFTER cart-validation.js (Phase 1).
   ============================================================ */

(function () {
  'use strict';

  // ---- Background design catalog (mirrors product page JS) ----
  const BG_DESIGNS_VEHICLE = [
    "Better-the-Farm-2023","Montana-Wilderness-Association-2023","Project-WET-Foundation-2023",
    "Ramsey-Keller-Memorial-2023","Richland-Youth-Hockey-2023","The-Way-Home-2023",
    "Tough-Enough-to-Wear-Pink-MT-2023","Two-percent-for-Conservation-2023","United-in-Light-2024",
    "United-Property-Owners-of-MT-2023-scaled-1200x600","University-of-MT-Clock-Tower-2023",
    "University-of-MT-Griz-2023","University-of-MT-Western-Foundation-2023","Veterans-Monument-Inc-2023",
    "Veterans-Navigation-Network-2024","Violence-Free-Crisis-Line-2023","Walleyes-Unlimited-of-MT-2023",
    "Western-Sustainability-Exchange-2023","YAAK-Valley-Forest-2023","Yellowstone-Forever-2023",
    "Yellowstone-Wildlife-Sanctuary-2023","Youth-Overcoming-Lifes-Obstacles-2023","YWCA-Missoula-2024",
    "Zoo-Montana-2023-1","Museum-of-the-Rockies-2023","National-Ski-Patrol-MT-Snowbowl-2023",
    "National-Wildlife-Federation-2023","Native-Ecosystmes-Council-2023","Neighbor-to-Neighbor-2023",
    "Northeast-MT-Fair-Rodeo-Committee-2023","Northern-Cheyenne-Tribe-2023","One-Heart-Warriors-2023",
    "Public-Land-Water-Access-Association-2023","Recycle-MT-Inc-2023","Rocky-Mountain-College-2023",
    "Rocky-Mountain-Elk-Foundation-2023","Rocky-Mountain-Medical-Foundation-2023",
    "Salish-Kootenai-College-2023","Search-Assist-2023","Somers-Volunteer-Firefighters-Association-2023",
    "South-Kalsipell-Volunteer-Firefighters-Association-2023","Stafford-Animal-Shelter-2023",
    "Sustainable-Montana-2023","Sweet-Grass-Community-Foundation-2023","The-Frontier-Institute-2023",
    "The-Heart-of-the-Valley-2023","The-Montana-Land-Reliance-2023","The-Vital-Ground-Foundation-2023",
    "Montana-Raptor-Conservation-Center-2023","Montana-Snowmobile-Association-2023",
    "Montana-Spay-Neuter-Task-Force-2023","Montana-State-Council-of-Professional-Firefighters-2023",
    "Montana-State-Fire-Chiefs-Association-2023","Montana-State-Golf-Association-2023",
    "Montana-Stockgrowers-Association-2023","Montana-Support-Our-Troops-2023","Montana-Tech-2023",
    "Montana-Timber-Legacy-2023","Montana-Veterans-Alliance-2023","Montana-Weed-Control-Association-2023",
    "Montana-Wild-Sheep-Foundation-2024","MSU-Go-Cats-2023","MSU-Great-Falls-College",
    "MSU-Mountains-Minds-2023","MSU-Northern-2023","Mule-Deer-Foundation-2023","Our-Montana-Inc-2023",
    "Outlaw-Baseball-Club-2023","Patriot-MT-Veteran-Affairs-2023","Pheasants-Forever-Inc-2023",
    "Postpartum-Resource-Group-2023","Prickly-Pear-Land-Trust-2023","Montana-Concerns-of-Police-Survivors-2023",
    "Montana-Council-of-Trout-Unlimited-2023","Montana-Cowboy-Hall-of-Fame-2023","Montana-Cutting-Horse-2023-1",
    "Montana-Environmental-Info-Center-2023","Montana-Family-Institute-2023","Montana-Farm-Bureau-Foundation-2023",
    "Montana-Food-Bank-Network-2023","Montana-Grains-Foundation-2023","Montana-Home-Private-Schools-2023",
    "Montana-Hope-Project-2023-1-1200x600","Montana-Horse-Sanctuary-2023","Montana-Loon-Society-2023",
    "Montana-Natural-History-2024","Montana-Pilots-Association-2023","Montana-Police-Protective-Association-2023",
    "Montana-Public-Policy-Center-2023","Montana-Public-Radio-UM-Foundation-2023",
    "Montana-Safety-Service-Council-Inc-2023","Montana-State-Parks-Foundation-Inc-2023",
    "Montana-Wildlife-Federation-2023","Montana-Youth-Sports-Association-2023","MSU-Billings-2023",
    "MSU-Bobcat-Club-2023","Flathead-Valley-Community-College-2023","Fort-Belknap-Indian-Community-2023",
    "International-Choral-Festival-2023","Jeannette-Rankin-Peace-Center-2023",
    "Laurel-Public-Library-Foundation-2024","Lewis-Clark-Bicentennial-2023","Lewis-Clark-Humane-Society-2023",
    "Livestock-Loss-Board-2023","Loving-HOME-Foundation-2023","Manhattan-Town-Council-2023",
    "Miles-Community-College-2023","Milestown-Communty-Improvement-Inc-2023",
    "Missoula-Butterfly-House-Insectarium-2023","Missoula-Downtown-Foundation-2023",
    "Missoula-Freestyle-Team-2023","Missoula-Horse-Council-Big-Sky-Horse-Park-2023",
    "Montana-4-H-Foundation-2023","Montana-Agricultural-Heritage-Foundation-2023",
    "Montana-Association-of-Symphony-Orchestras-2023","Montana-Audubon-2023",
    "Montana-Beyond-The-Classroom-2023","Montana-Bowhunter-Education-2023",
    "Montana-FFA-Foundation-Inc-2023","Montana-Mobile-Museum-2024","Cody-Dieruf-Benefit-Foundation-2023",
    "Community-Food-Ag-Coalition-2023","Community-Foundation-for-a-Better-Big-Fork-2023",
    "Compassion-MT-2023","Council-on-Wildlife-Fish-2023","Creating-Community-MT-2023",
    "Fort-Belknap-College-2023","Fossil-Rims-2023","Friends-of-Lee-Metcalf-National-Wildlife-Refuge-2023",
    "Friends-of-Montana-PBS-2023","Friends-of-NRA-2023","Gallatin-Ice-Foundation-Inc-2023",
    "Gallatin-Open-Lands-2023","Gallatin-River-Task-Force-2023","Gallatin-Valley-Land-Trust-2023",
    "Garnet-Preservation-Association-Inc-2023","Glacier-Institute-2023",
    "Glacier-National-Park-GNP-Conservancy-2023","Glasgow-Scotty-Booster-Club-2023",
    "Greater-Yellowstone-Coaltion-2023","Grizzly-Scholarship-Association-2023",
    "Grizzly-Wolf-Discovery-Center-2023","Helena-College-2023","Humane-of-Society-NW-MT-2023",
    "Bird-of-Pray-Foundation-2023","Bitterroot-Humane-Association-2023","Blackfeet-Tribe-2023",
    "Bob-Marshall-Foundation-2023","Boone-Crocket-Club-2023","Bridger-Ski-Foundation-2023",
    "Buffalo-Field-Campaign-2023","Butte-Silver-Bow-Gov-2023","Cancer-Support-Community-of-MT-2023",
    "Catalyst-for-Change-2023","Custer-Battlefield-Museum-2023","Dawson-Community-College-2023",
    "DEAP-Developmental-Educational-Assistance-Program-2023","Dress-for-Success-2023",
    "Ducks-Unlimited-Inc-2023","Eagle-Mount-Bozeman-2023","Eastgate-VFD-Association-2023",
    "Ecology-Project-International-2023","Elizabth-Custer-Library-Museum-2023",
    "Eureka-MT-Quilt-Show-2023","Experimental-Aircraft-Association-517-Inc-2023",
    "Five-Valleys-Land-Trust-2023","Flathead-County-Sheriffs-Posse-2023",
    "Flathead-Lake-Protection-Association-2023","1776-Foundation-2023","406-Pickle-Ball-Missoula-Inc-2023",
    "Absaroka-Beartooth-Wilderness-Foundation-2023","Alliance-for-the-Wild-Rockies-2023",
    "Alternative-Energy-Resources-2023","American-Red-Cross-Five-Rivers-District-2023",
    "Backcountry-Hunters-Anglers-2023","Baker-Baseball-Association-2023","Bear-Creek-Council-2023",
    "Beartooth-Back-Country-Horsemen-2023","Benefis-Mercy-Flight-2023","Big-Sky-Bravery-2023",
    "Big-Sky-Ski-Education-Fund-2023-1200x600","Bighorn-River-Alliance-2023",
    "Billings-Christian-School-Education-Foundation-2023","Blackfoot-Challenge-Inc-2023",
    "Carroll-College-2023","Chase-Hawks-Memorial-Association-2023","Chicks-n-Chaps-Inc-2023",
    "Citizens-Balanced-Use-2023","City-of-Billings-City-Council-2023","City-of-Laurel-2024",
    "City-of-Missoula-Parks-Rec-Dept-2023","Clark-Fork-Coalition-2023","A-Heart-For-Horses-2023",
    "American-Rivers-Inc-2023","Animal-Foundation-of-Great-Falls-2024","Biomimicry-Institute-2023-1200x600",
    "plate-reissued1991-300x152-1","plate-reissued2000-300x152-1","plate-reissued2006-300x152-1",
    "StandardAlternative1889Centennial","USS-Montana-Committee-2023-1"
  ];
  const BG_CDN_BASE = 'https://cdn.shopify.com/s/files/1/0642/8599/9281/files/';

  function $(s, r = document) { return r.querySelector(s); }
  function $$(s, r = document) { return Array.from(r.querySelectorAll(s)); }

  function imgUrlFor(name) { return BG_CDN_BASE + name + '.jpg'; }
  function displayName(name) { return name.replace(/-/g, ' '); }

  // ---- Wait for Phase 1 engine to be ready ----
  function whenReady(fn) {
    if (window.MTCartValidation && window.MTCartValidation.runOverallValidation) {
      fn();
    } else {
      setTimeout(() => whenReady(fn), 50);
    }
  }

  // ---- Background dropdown initialization ----
  function initBackgroundPickers() {
    $$('.cart-bg-picker__select').forEach((select) => {
      const designSet = select.dataset.bgDesignSet || 'vehicle';
      const designs = BG_DESIGNS_VEHICLE; // only vehicle set for now
      const currentValue = select.dataset.currentValue || '';

      const optionsHtml = ['<option value="">— Select a design —</option>']
        .concat(designs.map(d => `<option value="${d}">${displayName(d)}</option>`))
        .join('');
      select.innerHTML = optionsHtml;
      if (currentValue && designs.includes(currentValue)) {
        select.value = currentValue;
      }
      updatePreviewFor(select);

      select.addEventListener('change', () => {
        updatePreviewFor(select);
        triggerLineSave(select);
        if (window.MTCartValidation && window.MTCartValidation.runOverallValidation) {
          window.MTCartValidation.runOverallValidation();
        }
      });
    });

    // Browse-all buttons
    $$('.cart-bg-picker__browse-btn').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const lineEl = btn.closest('.cart-line-validation');
        openBackgroundModal(lineEl);
      });
    });
  }

  function updatePreviewFor(select) {
    const lineEl = select.closest('.cart-line-validation');
    const previewImg = lineEl.querySelector('[data-bg-preview-img]');
    const previewLabel = lineEl.querySelector('[data-bg-preview-label]');
    const value = select.value;
    if (value) {
      previewImg.src = imgUrlFor(value);
      previewImg.alt = displayName(value);
      previewImg.style.display = 'block';
      previewLabel.textContent = displayName(value);
    } else {
      previewImg.style.display = 'none';
      previewImg.src = '';
      previewLabel.textContent = 'Select a design above';
    }
  }

  // ---- Modal (lightbox) ----
  let modalActiveLineEl = null;
  let modalSelectedValue = '';

  function openBackgroundModal(lineEl) {
    modalActiveLineEl = lineEl;
    const select = lineEl.querySelector('.cart-bg-picker__select');
    modalSelectedValue = select.value;

    const modal = $('#cart-bg-modal');
    const grid = $('#cart-bg-modal-grid');
    grid.innerHTML = BG_DESIGNS_VEHICLE.map(d => `
      <div class="cart-bg-modal__item${d === modalSelectedValue ? ' is-selected' : ''}" data-bg-value="${d}">
        <img src="${imgUrlFor(d)}" alt="${displayName(d)}" loading="lazy" />
        <div class="cart-bg-modal__item-label">${displayName(d)}</div>
      </div>
    `).join('');

    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    updateModalConfirmBtn();

    const search = $('#cart-bg-modal-search');
    search.value = '';
    filterModalGrid('');
    search.focus();
  }

  function closeBackgroundModal() {
    const modal = $('#cart-bg-modal');
    modal.hidden = true;
    document.body.style.overflow = '';
    modalActiveLineEl = null;
    modalSelectedValue = '';
  }

  function confirmBackgroundModal() {
    if (!modalActiveLineEl || !modalSelectedValue) {
      closeBackgroundModal();
      return;
    }
    const select = modalActiveLineEl.querySelector('.cart-bg-picker__select');
    select.value = modalSelectedValue;
    select.dispatchEvent(new Event('change'));
    closeBackgroundModal();
  }

  function updateModalConfirmBtn() {
    const btn = $('#cart-bg-modal-confirm');
    btn.disabled = !modalSelectedValue;
    btn.textContent = modalSelectedValue
      ? `Use "${displayName(modalSelectedValue)}"`
      : 'Select a design';
  }

  function filterModalGrid(query) {
    const q = query.trim().toLowerCase();
    $$('#cart-bg-modal-grid .cart-bg-modal__item').forEach((item) => {
      const label = item.querySelector('.cart-bg-modal__item-label').textContent.toLowerCase();
      item.style.display = (!q || label.includes(q)) ? '' : 'none';
    });
  }

  function bindModalEvents() {
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-bg-modal-close]')) {
        closeBackgroundModal();
      }
      const item = e.target.closest('.cart-bg-modal__item');
      if (item) {
        modalSelectedValue = item.dataset.bgValue;
        $$('#cart-bg-modal-grid .cart-bg-modal__item').forEach(el => el.classList.remove('is-selected'));
        item.classList.add('is-selected');
        updateModalConfirmBtn();
      }
    });
    $('#cart-bg-modal-confirm').addEventListener('click', confirmBackgroundModal);
    $('#cart-bg-modal-search').addEventListener('input', (e) => filterModalGrid(e.target.value));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !$('#cart-bg-modal').hidden) closeBackgroundModal();
    });
  }

  // ---- Typographic normalization (all free-text cart fields) ----
  // Phones/tablets auto-insert "smart" punctuation (David's -> David\u2019s),
  // and the order pipeline only tolerates plain ASCII. Every free-text field
  // runs through this as the user types AND again when properties are
  // collected for /cart/change.js, so a typographic apostrophe can never
  // reach a line-item property regardless of which field it was typed into.
  function normalizeTypography(value) {
    return String(value)
      .normalize('NFKD')
      .replace(/[\u0300-\u036F]/g, '')                              // strip combining diacritics (e\u0301 -> e)
      .replace(/[\u2018\u2019\u201A\u201B\u2032\u02BC\u02B9\u0060\u00B4]/g, "'") // curly/smart single quotes, primes, backticks -> apostrophe
      .replace(/[\u201C\u201D\u201E\u201F\u2033]/g, '"')             // curly double quotes -> straight double quote
      .replace(/[\u2010-\u2015\u2212]/g, '-')                       // hyphen/dash variants -> hyphen
      .replace(/\u2026/g, '...')                                     // ellipsis -> three dots
      .replace(/[\u00A0\u2000-\u200B\u202F\u205F\u3000]/g, ' ')      // unicode spaces -> plain space
      .replace(/\r\n?/g, '\n')                                       // normalize line endings (textareas)
      .replace(/[^\x20-\x7E\n]/g, '');                               // drop anything else non-ASCII (emoji, symbols)
  }

  // ---- Company/LLC name character policy ----
  // Montana SOS registers business names with ordinary punctuation, but the
  // order pipeline only tolerates this set. Apostrophes are legal in LLC names
  // ("Mick's Garage LLC") so they stay allowed; typographic variants are
  // normalized to plain ASCII by normalizeTypography and everything outside
  // the whitelist (including double quotes) is stripped as the user types.
  const NAME_DISALLOWED_RE = /[^A-Za-z0-9 &'\-.,()#/+]/g;
  function sanitizeCompanyNameInput(value) {
    return normalizeTypography(value).replace(NAME_DISALLOWED_RE, '');
  }

  // Replace an input's value with its sanitized form while keeping the caret
  // roughly where the user left it.
  function applySanitizedValue(input, cleaned) {
    if (input.value === cleaned) return;
    const delta = input.value.length - cleaned.length;
    const caret = Math.max(0, (input.selectionStart || cleaned.length) - delta);
    input.value = cleaned;
    try { input.setSelectionRange(caret, caret); } catch (e) { /* not supported on this input type */ }
  }

  function handleCompanyNameInput(minLength, event) {
    applySanitizedValue(event.target, sanitizeCompanyNameInput(event.target.value));
    handleTextFieldInput(minLength, event);
  }

  // ---- Company Name, Meaning input handlers ----
function initTextValidators() {
    $$('.cart-line-validation input[data-field^="company-"]').forEach((input) => {
      input.addEventListener('input', handleCompanyNameInput.bind(null, 3));
    });
    $$('.cart-line-validation input[data-field^="meaning-"]').forEach((input) => {
      input.addEventListener('input', handleTextFieldInput.bind(null, 3));
    });
    $$('.cart-line-validation input[data-field="transfer-llc-name"]').forEach((input) => {
      input.addEventListener('input', handleCompanyNameInput.bind(null, 3));
    });
    $$('.cart-line-validation input[data-field="current-owner-name"]').forEach((input) => {
      input.addEventListener('input', handleTextFieldInput.bind(null, 3));
    });
    $$('.cart-line-validation input[data-field="current-owner-email"]').forEach((input) => {
      input.addEventListener('input', handleEmailFieldInput);
    });
    $$('.cart-line-validation input[data-field="new-owner-name"]').forEach((input) => {
      input.addEventListener('input', handleTextFieldInput.bind(null, 3));
    });
    $$('.cart-line-validation input[data-field="new-owner-email"]').forEach((input) => {
      input.addEventListener('input', handleEmailFieldInput);
    });
    $$('.cart-line-validation input[data-field="new-owner-phone"]').forEach((input) => {
      input.addEventListener('input', handlePhoneFieldInput);
    });
    $$('.cart-line-validation textarea[data-field="new-owner-address"]').forEach((input) => {
      input.addEventListener('input', handleTextFieldInput.bind(null, 10));
    });
    $$('.cart-line-validation input[data-field="prior-registrar"]').forEach((input) => {
      input.addEventListener('input', handleTextFieldInput.bind(null, 3));
    });
    $$('.cart-line-validation textarea[data-field="prior-registrar-address"]').forEach((input) => {
      input.addEventListener('input', handleTextFieldInput.bind(null, 10));
    });
    $$('.cart-line-validation input[data-field="registered-llc-name"]').forEach((input) => {
      input.addEventListener('input', handleCompanyNameInput.bind(null, 3));
    });
    // Agency transfer fields + renewal/permanent count selects (bound here ONCE,
    // not inside runOverallValidation — see fix for the Owner Name typing freeze).
    $$('.cart-line-validation input[data-field="agency-owner-name"]').forEach((input) => {
      input.addEventListener('input', handleTextFieldInput.bind(null, 3));
    });
    $$('.cart-line-validation input[data-field="agency-owner-email"]').forEach((input) => {
      input.addEventListener('input', handleEmailFieldInput);
    });
    $$('.cart-line-validation select[data-field="renewable-count"]').forEach((select) => {
      select.addEventListener('change', handleCountSelectInput);
    });
    $$('.cart-line-validation select[data-field="permanent-count"]').forEach((select) => {
      select.addEventListener('change', handleCountSelectInput);
    });
    $$('.cart-line-validation select[data-field="vehicle-type"]').forEach((select) => {
      select.addEventListener('change', handleCountSelectInput);
    });
}

  function handleTextFieldInput(minLength, event) {
    const input = event.target;
    applySanitizedValue(input, normalizeTypography(input.value));
    const value = input.value.trim();
    const isValid = value.length >= minLength;

    input.classList.toggle('is-valid', isValid);
    input.classList.toggle('is-invalid', !isValid && value.length > 0);

    const errorEl = input.parentElement.querySelector('.cart-field__error');
    if (errorEl) errorEl.style.display = (!isValid && value.length > 0) ? 'block' : 'none';

    triggerLineSave(input);
    if (window.MTCartValidation && window.MTCartValidation.runOverallValidation) {
      window.MTCartValidation.runOverallValidation();
    }
  }

  function handleEmailFieldInput(event) {
    const input = event.target;
    const value = input.value.trim();
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);

    input.classList.toggle('is-valid', isValid);
    input.classList.toggle('is-invalid', !isValid && value.length > 0);

    const errorEl = input.parentElement.querySelector('.cart-field__error');
    if (errorEl) errorEl.style.display = (!isValid && value.length > 0) ? 'block' : 'none';

    triggerLineSave(input);
    if (window.MTCartValidation && window.MTCartValidation.runOverallValidation) {
      window.MTCartValidation.runOverallValidation();
    }
}

function handlePhoneFieldInput(event) {
    const input = event.target;
    const digits = input.value.replace(/\D/g, '');
    const isValid = digits.length >= 10;

    input.classList.toggle('is-valid', isValid);
    input.classList.toggle('is-invalid', !isValid && input.value.length > 0);

    const errorEl = input.parentElement.querySelector('.cart-field__error');
    if (errorEl) errorEl.style.display = (!isValid && input.value.length > 0) ? 'block' : 'none';

    triggerLineSave(input);
    if (window.MTCartValidation && window.MTCartValidation.runOverallValidation) {
      window.MTCartValidation.runOverallValidation();
    }
}
function handleCountSelectInput(event) {
    const select = event.target;
    const isValid = !!select.value;

    select.classList.toggle('is-valid', isValid);
    select.classList.toggle('is-invalid', !isValid);

    const errorEl = select.parentElement.querySelector('.cart-field__error');
    if (errorEl) errorEl.style.display = (!isValid) ? 'block' : 'none';

    triggerLineSave(select);
    if (window.MTCartValidation && window.MTCartValidation.runOverallValidation) {
      window.MTCartValidation.runOverallValidation();
    }
}
  function triggerLineSave(el) {
    const lineEl = el.closest('.cart-line-validation');
    if (!lineEl) return;
    // Phase 1 engine has its own debouncedSaveLine; we re-implement minimally here
    // to write Company/Meaning/Tag Style properties.
    if (window.MTCartValidation && typeof window.MTCartValidation._saveLine === 'function') {
      window.MTCartValidation._saveLine(lineEl);
    } else {
      // Fallback: directly POST to /cart/change.js
      directSaveLine(lineEl);
    }
  }

  // ---- Direct line save (extends Phase 1 collection to include phase 2 fields) ----
  const directSaveQueue = new Map();
  function directSaveLine(lineEl) {
    const lineIndex = parseInt(lineEl.dataset.lineIndex, 10);
    if (!directSaveQueue.has(lineIndex)) {
      let timer;
      directSaveQueue.set(lineIndex, (idx, el) => {
        clearTimeout(timer);
        timer = setTimeout(() => doDirectSave(idx, el), 600);
      });
    }
    directSaveQueue.get(lineIndex)(lineIndex, lineEl);
  }

  async function doDirectSave(lineIndex, lineEl) {
    const props = collectAllProperties(lineEl);
    // Expose so Phase 1's collector can delegate to this comprehensive version
    
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, properties: props }),
      });
    } catch (err) {
      console.error('[cart-validation-phase2] save error', err);
    }
  }

  function collectAllProperties(lineEl) {
    const props = {};
    const vehicleGroup = lineEl.dataset.vehicleGroup;
    if (vehicleGroup) props['_Vehicle Group'] = vehicleGroup;

    const vinInput = lineEl.querySelector('input[data-field="vin"], input[data-field="vin-synced"]');
    if (vinInput && vinInput.value) props['VIN'] = vinInput.value;

    // Plate text
    ['plate-1', 'plate-2', 'plate-3'].forEach((f, i) => {
      const el = lineEl.querySelector(`input[data-field="${f}"]`);
      if (el && el.value) props[`Custom Plate ${i + 1}`] = el.value;
    });
    // Plate meanings
    ['meaning-1', 'meaning-2', 'meaning-3'].forEach((f, i) => {
      const el = lineEl.querySelector(`input[data-field="${f}"]`);
      if (el && el.value) props[`Custom Plate ${i + 1} Meaning`] = el.value;
    });
    // Company names
    const c1 = lineEl.querySelector('input[data-field="company-1"]');
    const c2 = lineEl.querySelector('input[data-field="company-2"]');
    const c3 = lineEl.querySelector('input[data-field="company-3"]');
    if (c1 && c1.value) props['Company Name'] = sanitizeCompanyNameInput(c1.value);
    if (c2 && c2.value) props['Company Name (2nd Choice)'] = sanitizeCompanyNameInput(c2.value);
    if (c3 && c3.value) props['Company Name (3rd Choice)'] = sanitizeCompanyNameInput(c3.value);

    // Tag style (Custom Background)
    const tagStyle = lineEl.querySelector('select[data-field="tag-style"]');
    if (tagStyle && tagStyle.value) props['Tag Style'] = tagStyle.value;

    // Vehicle Type (FlexTag 130) — value must match Dashboard vehicle types verbatim
    const vehicleType = lineEl.querySelector('select[data-field="vehicle-type"]');
    if (vehicleType && vehicleType.value) props['Vehicle Type'] = vehicleType.value;

    // Transfer of Ownership fields
    // Current owner fields (Transfer of Ownership verification)
    // LLC being transferred
    const transferLlcName = lineEl.querySelector('input[data-field="transfer-llc-name"]');
    const currentOwnerName = lineEl.querySelector('input[data-field="current-owner-name"]');
    const currentOwnerEmail = lineEl.querySelector('input[data-field="current-owner-email"]');
    const newOwnerName = lineEl.querySelector('input[data-field="new-owner-name"]');
    const newOwnerEmail = lineEl.querySelector('input[data-field="new-owner-email"]');
    const newOwnerPhone = lineEl.querySelector('input[data-field="new-owner-phone"]');
    const newOwnerAddress = lineEl.querySelector('textarea[data-field="new-owner-address"]');
    if (transferLlcName && transferLlcName.value) props['LLC Name'] = sanitizeCompanyNameInput(transferLlcName.value).trim();
    if (currentOwnerName && currentOwnerName.value) props['Current Owner Name'] = currentOwnerName.value.trim();
    if (currentOwnerEmail && currentOwnerEmail.value) props['Current Owner Email'] = currentOwnerEmail.value.trim();
    if (newOwnerName && newOwnerName.value) props['New Owner Name'] = newOwnerName.value.trim();
    if (newOwnerEmail && newOwnerEmail.value) props['New Owner Email'] = newOwnerEmail.value.trim();
    if (newOwnerPhone && newOwnerPhone.value) props['New Owner Phone'] = newOwnerPhone.value.trim();
    if (newOwnerAddress && newOwnerAddress.value) props['New Owner Mailing Address'] = newOwnerAddress.value.trim();

    // Agency Transfer fields
    // Agency Transfer fields
    const priorRegistrar = lineEl.querySelector('input[data-field="prior-registrar"]');
    const priorRegistrarAddress = lineEl.querySelector('textarea[data-field="prior-registrar-address"]');
    const registeredLlcName = lineEl.querySelector('input[data-field="registered-llc-name"]');
    const agencyOwnerName = lineEl.querySelector('input[data-field="agency-owner-name"]');
    const agencyOwnerEmail = lineEl.querySelector('input[data-field="agency-owner-email"]');
    const renewableCount = lineEl.querySelector('select[data-field="renewable-count"]');
    const permanentCount = lineEl.querySelector('select[data-field="permanent-count"]');
    if (priorRegistrar && priorRegistrar.value) props['Current Registrar'] = priorRegistrar.value.trim();
    if (priorRegistrarAddress && priorRegistrarAddress.value) props['Current Registrar Address'] = priorRegistrarAddress.value.trim();
    if (registeredLlcName && registeredLlcName.value) props['LLC Name (as registered)'] = sanitizeCompanyNameInput(registeredLlcName.value).trim();
    if (agencyOwnerName && agencyOwnerName.value) props['Owner Name'] = agencyOwnerName.value.trim();
    if (agencyOwnerEmail && agencyOwnerEmail.value) props['Owner Email'] = agencyOwnerEmail.value.trim();
    if (renewableCount && renewableCount.value) props['Vehicles with Renewable Registration'] = renewableCount.value;
    if (permanentCount && permanentCount.value) props['Vehicles with Permanent Registration'] = permanentCount.value;

    // Apply master Control Number for any item that needs it
    const lineType = lineEl.dataset.lineType;
    const llcLevelTypes = ['additional','transfer-ownership','transfer-agency','llc-renewal','llc-restoration','duplicate-title'];
    if (llcLevelTypes.indexOf(lineType) !== -1 && window.MTCartValidation && window.MTCartValidation.state) {
      const masterCN = window.MTCartValidation.state.masterControlNumber;
      if (masterCN && /^[LCDFR][A-Za-z0-9]{7}$/.test(masterCN)) {
        props['Control Number'] = masterCN;
      }
    }

    // Final safety net: no typographic punctuation / non-ASCII may persist to
    // any line-item property, including values pre-filled from an older cart.
    Object.keys(props).forEach((key) => {
      if (typeof props[key] === 'string') props[key] = normalizeTypography(props[key]);
    });

    return props;
  }

    window.MTCartCollectAllProperties = collectAllProperties;

  // ---- Extend Phase 1 overall validation to include Phase 2 fields ----
  function extendValidation() {
    if (!window.MTCartValidation) return;
    const originalRun = window.MTCartValidation.runOverallValidation;

    window.MTCartValidation.runOverallValidation = function () {
      // Run Phase 1 checks (returns nothing; reads DOM, gates button)
      // We need to count Phase 2 issues too. Rebuild status from scratch:
      let issues = 0;

      // Phase 1 checks (mirror logic)
      const masterControl = document.querySelector('#cart-master-control-input');
      if (masterControl && !/^[LCDFR][A-Za-z0-9]{7}$/.test(masterControl.value)) issues++;
      document.querySelectorAll('.cart-line-validation input[data-field="vin"]').forEach((i) => {
        if (!/^[A-Z0-9-]{2,20}$/.test(i.value)) issues++;
      });
      document.querySelectorAll('.cart-line-validation input[data-field^="plate-"]').forEach((i) => {
        const max = parseInt(i.dataset.maxChars, 10) || 7;
        const re = new RegExp(`^[A-Z0-9 &]{2,${max}}$`);
        if (!re.test(i.value)) issues++;
      });

      // Phase 2 checks — original
      document.querySelectorAll('.cart-line-validation input[data-field^="company-"]').forEach((i) => {
        if (i.value.trim().length < 3) issues++;
      });
      document.querySelectorAll('.cart-line-validation input[data-field^="meaning-"]').forEach((i) => {
        if (i.value.trim().length < 3) issues++;
      });
      document.querySelectorAll('.cart-line-validation select[data-field="tag-style"]').forEach((s) => {
        if (!s.value) issues++;
      });
      document.querySelectorAll('.cart-line-validation select[data-field="vehicle-type"]').forEach((s) => {
        if (!s.value) issues++;
      });

      // Phase 3 checks — Transfer fields
      document.querySelectorAll('.cart-line-validation input[data-field="transfer-llc-name"]').forEach((i) => {
        if (i.value.trim().length < 3) issues++;
      });
      document.querySelectorAll('.cart-line-validation input[data-field="current-owner-name"]').forEach((i) => {
        if (i.value.trim().length < 3) issues++;
      });
      document.querySelectorAll('.cart-line-validation input[data-field="current-owner-email"]').forEach((i) => {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(i.value.trim())) issues++;
      });
      document.querySelectorAll('.cart-line-validation input[data-field="new-owner-name"]').forEach((i) => {
        if (i.value.trim().length < 3) issues++;
      });
      document.querySelectorAll('.cart-line-validation input[data-field="new-owner-email"]').forEach((i) => {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(i.value.trim())) issues++;
      });
      document.querySelectorAll('.cart-line-validation input[data-field="new-owner-phone"]').forEach((i) => {
        const digits = i.value.replace(/\D/g, '');
        if (digits.length < 10) issues++;
      });
      document.querySelectorAll('.cart-line-validation textarea[data-field="new-owner-address"]').forEach((t) => {
        if (t.value.trim().length < 10) issues++;
      });
      document.querySelectorAll('.cart-line-validation input[data-field="prior-registrar"]').forEach((i) => {
        if (i.value.trim().length < 3) issues++;
      });
      document.querySelectorAll('.cart-line-validation textarea[data-field="prior-registrar-address"]').forEach((t) => {
        if (t.value.trim().length < 10) issues++;
      });
      document.querySelectorAll('.cart-line-validation input[data-field="registered-llc-name"]').forEach((i) => {
        if (i.value.trim().length < 3) issues++;
      });
      document.querySelectorAll('.cart-line-validation input[data-field="agency-owner-name"]').forEach((i) => {
        if (i.value.trim().length < 3) issues++;
      });
      document.querySelectorAll('.cart-line-validation input[data-field="agency-owner-email"]').forEach((i) => {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(i.value.trim())) issues++;
      });
      document.querySelectorAll('.cart-line-validation select[data-field="renewable-count"]').forEach((s) => {
        if (!s.value) issues++;
      });
      document.querySelectorAll('.cart-line-validation select[data-field="permanent-count"]').forEach((s) => {
        if (!s.value) issues++;
      });

      // Apply gating
      const allValid = issues === 0;
      const statusEl = document.querySelector('#cart-validation-count');
      const containerEl = document.querySelector('#cart-validation-status');
      if (statusEl) {
        if (allValid) {
          statusEl.textContent = '✓ All required fields complete. You can proceed to checkout.';
          containerEl && containerEl.classList.add('is-valid');
        } else {
          statusEl.textContent = `${issues} field${issues === 1 ? '' : 's'} still need attention.`;
          containerEl && containerEl.classList.remove('is-valid');
        }
      }
      document.querySelectorAll('button[name="checkout"], input[name="checkout"], #checkout, .cart__checkout-button').forEach((btn) => {
        btn.disabled = !allValid;
        btn.classList.toggle('cart-checkout-button--gated', !allValid);
        if (!allValid) btn.setAttribute('aria-disabled', 'true');
        else btn.removeAttribute('aria-disabled');
      });
    };

    // Expose minimal save hook so handlers above can call it
    window.MTCartValidation._saveLine = directSaveLine;
  }

  // ---- Second-Package warning ----
  function checkPackageCount() {
    const packageLines = $$('.cart-line-validation[data-line-type="package"]');
    if (packageLines.length > 1) {
      let warningEl = $('#cart-package-warning');
      if (!warningEl) {
        warningEl = document.createElement('div');
        warningEl.id = 'cart-package-warning';
        warningEl.className = 'cart-package-warning';
        warningEl.innerHTML = `
          <strong>⚠ Multiple LLC packages detected.</strong>
          You have ${packageLines.length} new-LLC package items in your cart. Each order should form only one LLC.
          Please remove extras or contact concierge to split this into separate orders.
        `;
        const callout = $('#cart-welcome-callout');
        if (callout) callout.after(warningEl);
      }
    }
  }

  // ---- Boot ----
  function init() {
    whenReady(() => {
      initBackgroundPickers();
      initTextValidators();
      bindModalEvents();
      extendValidation();
      checkPackageCount();
      // Re-run validation now that Phase 2 fields are wired
      if (window.MTCartValidation.runOverallValidation) {
        window.MTCartValidation.runOverallValidation();
      }
      console.log('[cart-validation-phase2] initialized');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();